// @todo: Migrate to 'Toast' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {toast} from '@wandb/weave/common/components/elements/Toast';
// @todo: Migrate to @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components';
import React, {FC, useCallback, useMemo, useState} from 'react';
import {useHistory} from 'react-router';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon, InputOnChangeData, Modal} from 'semantic-ui-react';

import {useDeleteTeamMutation} from '../../generated/graphql';
import {propagateErrorsContext} from '../../util/errors';
import * as S from './DeleteTeamModal.styles';

interface DeleteTeamModalProps {
  teamName: string;
}

interface LocationState {
  redirectUrl: string;
}

export const DeleteTeamModal: FC<DeleteTeamModalProps> = ({teamName}) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [confirmationInput, setConfirmationInput] = useState('');
  const history = useHistory<LocationState>();
  const location = history.location;
  const redirectUrl = location?.state?.redirectUrl
    ? location.state.redirectUrl
    : '/home';

  const onDeleteUserConfirmationChange = useCallback(
    (_, data: InputOnChangeData) => {
      setConfirmationInput(data.value);
    },
    [setConfirmationInput]
  );
  const isDeleteDisabled = useMemo(
    () => confirmationInput !== teamName,
    [confirmationInput, teamName]
  );

  const [deleteTeam, {loading}] = useDeleteTeamMutation({
    context: propagateErrorsContext(),
    onCompleted: () => {
      window.analytics?.track('Team Deleted');
      history.push(redirectUrl);
    },
    onError: () => {
      window.analytics?.track('Team Delete Failed');
      toast('Unable to delete team');
    },
  });

  return (
    <Modal
      open={showModal}
      onClose={() => setShowModal(false)}
      style={{width: '550px'}} // update width manually here until semantic-ui modal is replaced
      trigger={
        <Button
          variant="destructive"
          size="small"
          className="p-8"
          onClick={() => setShowModal(true)}>
          Delete team
        </Button>
      }>
      <Modal.Header>
        <Icon name="exclamation triangle" />
        Delete team
      </Modal.Header>
      <Modal.Content>
        {loading ? (
          <p>Team deletion in progress...</p>
        ) : (
          <>
            <p>
              Are you sure you want to <b>DELETE</b> the team <b>{teamName}</b>?
            </p>
            <p>
              <b>This action cannot be undone.</b>
            </p>
            <p>To proceed, please type the team name below.</p>
            <S.DeleteTeamInput
              placeholder={teamName}
              onChange={onDeleteUserConfirmationChange}
            />
          </>
        )}
      </Modal.Content>
      {!loading && (
        <Modal.Actions>
          <S.ButtonWrapper>
            <Button
              variant="secondary"
              size="small"
              className="mx-5 p-10"
              onClick={() => setShowModal(false)}>
              Cancel
            </Button>
            <Button
              variant={isDeleteDisabled ? 'ghost' : 'destructive'}
              size="small"
              className="mx-5 p-10"
              onClick={() => {
                deleteTeam({
                  variables: {teamName},
                });
              }}
              disabled={isDeleteDisabled}>
              Delete
            </Button>
          </S.ButtonWrapper>
        </Modal.Actions>
      )}
    </Modal>
  );
};
